module.exports = __webpack_public_path__ + "img/room1.fcd57c23.jpg";